import axios from 'axios';
import { Loading, Message } from 'element-ui';
import qs from 'qs';
const http = {};

export const baseURL = '';

var instance = axios.create({
    timeout: 5000,
    baseURL,
    validateStatus(status) {
        switch (status) {
            case 400:
                Message.error('请求出错');
                break;
            case 401:
                Message.warning({
                    message: '授权失败，请重新登录',
                });
                // store.commit('LogOut')
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000)
                return;
            case 403:
                Message.warning({
                    message: '拒绝访问',
                });
                break;
            case 404:
                Message.warning({
                    message: '请求错误,未找到该资源',
                });
                break;
            case 500:
                Message.warning({
                    message: '服务端错误',
                });
                break;
        }
        return status >= 200 && status < 300;
    },
});
let mask = {}; //遮罩对象
// 添加请求拦截器
instance.interceptors.request.use(
    function(config) {
        // 请求头添加token
        if (config[0] == true) {
            mask = Loading.service({ fullscreen: true, text: '拼命加载中....' });
        }
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

// 响应拦截器即异常处理
instance.interceptors.response.use(
    response => {
        if (typeof mask.close == 'function') {
            mask.close();
        }
        return response;
    },
    err => {
        if (err && err.response) {
        } else {
            err.message = '连接服务器失败';
        }
        // Message.error({
        //     message: err.message,
        // });
        return Promise.reject(err.response);
    }
);

http.post = async function(url, data, config, isMask) {
    if (data instanceof FormData) {
        return await instance.post(url, data, config);
    }
    if (config == true || arguments[3] == true) {
        return await instance.post(url, data, true);
    } else {
        return await instance.post(url, qs.stringify(data), config);
    }
};

http.get = async function(url, data = {}, config, isMask) {
    let get_url = getUrlPara(url, data, this);
    if (config == true || arguments[2] == true) {
        return await instance.get(get_url, true);
    } else {
        return await instance.get(get_url, { config });
    }
};

const getUrlPara = (url, req, context) => {
    return JSON.stringify(req) === '{}' ? url : url + '?' + geSearchParams(req, context);
};
const geSearchParams = (req, context) => {
    let arr = [];
    Object.keys(req).forEach(key => {
        arr.push(key + '=' + req[key]);
    });
    return arr.join('&');
};

export default http;



// WEBPACK FOOTER //
// ./src/api/fetch.js